var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialHours = function SvgSocialHours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-hours_svg2__a",
    x1: 8.24,
    x2: 175.95,
    y1: 191.47,
    y2: 25.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__b",
    x1: -10.99,
    x2: 156.73,
    y1: 172.05,
    y2: 6.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__c",
    x1: -60.51,
    x2: 107.21,
    y1: 122.02,
    y2: -44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__d",
    x1: 31.74,
    x2: 199.46,
    y1: 215.21,
    y2: 49.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__e",
    x1: 35.85,
    x2: 203.57,
    y1: 219.37,
    y2: 53.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__f",
    x1: 3.63,
    x2: 171.34,
    y1: 186.81,
    y2: 20.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__g",
    x1: 30.9,
    x2: 198.62,
    y1: 214.37,
    y2: 48.34,
    gradientTransform: "rotate(45 86.692 159.14)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__h",
    x1: 57.79,
    x2: 225.51,
    y1: 241.53,
    y2: 75.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__i",
    x1: 68.82,
    x2: 236.54,
    y1: 252.68,
    y2: 86.65,
    gradientTransform: "rotate(44.98 163.31 159.124)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__j",
    x1: 57.52,
    x2: 225.23,
    y1: 241.25,
    y2: 75.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#social-hours_svg2__a",
    id: "social-hours_svg2__k",
    x1: 30.52,
    x2: 198.23,
    y1: 213.98,
    y2: 47.95,
    gradientTransform: "rotate(45.01 163.287 82.525)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M33.33 129.17h8.33v66.67h-8.33z",
    style: {
      fill: "url(#social-hours_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 125V79.17c0-13.79-11.21-25-25-25H25c-13.79 0-25 11.21-25 25V125c0 2.3 1.87 4.17 4.17 4.17h12.5v66.67H25v-83.33h-8.33v8.33H8.34V79.17c0-9.19 7.48-16.67 16.67-16.67h25c9.19 0 16.67 7.48 16.67 16.67v41.67h-8.33v-8.33h-8.33v83.33h8.33v-66.67h12.5c2.3 0 4.17-1.86 4.17-4.17Z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 45.83c11.49 0 20.83-9.35 20.83-20.83S48.99 4.17 37.5 4.17 16.67 13.52 16.67 25s9.35 20.83 20.83 20.83m0-33.33C44.39 12.5 50 18.11 50 25s-5.61 12.5-12.5 12.5S25 31.89 25 25s5.61-12.5 12.5-12.5",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 45.83c-12.35 0-24.57 3.05-35.3 8.83A4.18 4.18 0 0 0 88 60.3a4.167 4.167 0 0 0 5.64 1.7c9.67-5.2 20.22-7.84 31.36-7.84 36.76 0 66.67 29.91 66.67 66.67S161.76 187.5 125 187.5c-17.7 0-34.4-6.97-47.05-19.61a4.16 4.16 0 0 0-5.89 0 4.16 4.16 0 0 0 0 5.89c14.22 14.22 33.03 22.06 52.95 22.06 41.35 0 75-33.65 75-75s-33.65-75-75-75Z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83 109.05c-4.85 1.72-8.33 6.35-8.33 11.78 0 6.89 5.61 12.5 12.5 12.5 1.93 0 3.75-.44 5.39-1.22l16.67 16.67c.81.81 1.88 1.22 2.95 1.22s2.13-.41 2.95-1.22a4.16 4.16 0 0 0 0-5.89l-16.67-16.67c.78-1.63 1.22-3.46 1.22-5.39 0-5.43-3.48-10.06-8.33-11.78V91.67c0-2.3-1.86-4.17-4.17-4.17s-4.17 1.87-4.17 4.17v17.38Zm4.17 7.62c2.3 0 4.17 1.87 4.17 4.17s-1.87 4.17-4.17 4.17-4.17-1.87-4.17-4.17 1.87-4.17 4.17-4.17",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83 62.5h8.33v8.33h-8.33z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53 154.97h8.34v8.33h-8.34z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__g)"
    },
    transform: "rotate(-45 86.694 159.13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83 170.83h8.33v8.33h-8.33z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15 154.97h8.33v8.33h-8.33z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__i)"
    },
    transform: "rotate(-44.98 163.298 159.138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 116.67h8.33V125H175z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.13 78.37h8.33v8.33h-8.33z",
    style: {
      strokeWidth: 0,
      fill: "url(#social-hours_svg2__k)"
    },
    transform: "rotate(-45.01 163.295 82.53)"
  }));
};
export default SvgSocialHours;